(() => {
  const doc = document.documentElement;
  const header = document.querySelector('[data-site-header]');
  const onScroll = () => { if (header) header.classList.toggle('is-scrolled', window.scrollY > 28); };
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });

  document.querySelectorAll('[data-menu-toggle]').forEach(btn => {
    btn.addEventListener('click', () => doc.classList.toggle('menu-open'));
  });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('in-view'); });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));

  
  document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const url = new URL(anchor.getAttribute('href'), window.location.href);
      if (url.pathname === window.location.pathname && url.hash) {
        const target = document.querySelector(url.hash);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', url.hash); doc.classList.remove('menu-open'); }
      }
    });
  });
})();
